import type { Language } from '@packages/config';
import type { Audiences } from '../../../interfaces';

export const promotionBannerCacheKey = ({
  language,
  audience,
  platform,
  previewTestDate,
  shopId,
}: {
  language?: Language;
  audience?: Audiences;
  platform?: 'app' | 'web';
  previewTestDate?: string;
  shopId?: string;
}) =>
  ['promotionBannerData', language, audience, platform, previewTestDate, shopId]
    .filter(Boolean)
    .join('-');
